export default "__VITE_ASSET__CZ$qpFcx__"